import { multiply } from '@/views/common/u-contract'

// 建筑面积更改
export function buildAreaChange(info) {
    if (info.buildArea && info.unitPrice) {
        // 计算租金
        info.rent =
            (multiply(info.buildArea) * multiply(info.unitPrice)) / 10000
        // 计算押金
        changeDeposit(info)
    }
}

// 单价更改
export function unitPriceChange(info) {
    if (info.unitPrice && info.buildArea) {
        // 计算租金
        info.rent =
            (multiply(info.unitPrice) * multiply(info.buildArea)) / 10000
        // 计算押金
        changeDeposit(info)
    }
}

// 租金更改
// val 交租方式对象 info 数据源 isChangeDeposit 是否更改租约，默认更改
export function rentChange(info, isChangeDeposit = true) {
    // 租金存在，建筑面积存在-计算单价
    // 租金为空，单价为空
    if (info.rent && info.buildArea - 0) {
        info.unitPrice = (info.rent / info.buildArea).toFixed(2)
        this.$refs.info.validate()
    } else if (!info.rent) {
        info.unitPrice = 0
        this.$refs.info.validate()
    }
    if (isChangeDeposit) {
        changeDeposit(info)
    }
}

// 交租方式更改
// val 交租方式对象 info 数据源 isChangeDeposit 是否更改租约，默认更改
export function changeRentMode(val, info, isChangeDeposit = true) {
    info.depositPayMethod = val.depositPayMethod
    info.rentPayMethod = val.rentPayMethod

    if (isChangeDeposit) {
        changeDeposit(info)
    }
}

// 更改押金
export function changeDeposit(info) {
    // 租金存在，押金方式存在且<'4'(自定义)，相乘
    const dMethod = info.depositPayMethod
    if (info.rent !== '' && dMethod !== '' && dMethod !== '4') {
        info.deposit = info.rent * dMethod
    } /* else {
        info.deposit = 0;
    }*/
}
